import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import References from "../../components/References";
import BluePerson from "../../assets/module-1/blue_person.svg";
import PetScan from "../../assets/module-1/pet.svg";
import Clock from "../../assets/module-1/clock.svg";
import DownArrow from "../../assets/module-1/down-arrow-section.svg";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_3_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main>
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.3.1 Streamlined Procedure<sup>1</sup>
            </h1>
            <p className="mt-1 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <div
              className="blue-rounded-border col-sm-12 col-md-6 offset-md-3 light-blue-bg"
              style={{ minHeight: "320px" }}
            >
              <LdsImage
                src={BluePerson}
                alt="Icon of a person with text: 'Injection followed by 30-50 minute uptake.'"
                style={{ maxWidth: "100px" }}
                className="mx-auto d-block mt-3 mb-3 mt-5"
              />
              <p className="h5 text-center b mb-5 trade">
                Injection followed by
                <span className="fz-display d-inline-block col-sm-12">
                  30-50
                </span>
                Minute Uptake
              </p>
            </div>
            <div className="col-sm-12">
              <LdsImage
                src={DownArrow}
                alt="Down arrow"
                style={{ maxWidth: "60px" }}
                className="mx-auto d-block mt-4 mb-4"
              />
            </div>
            <div
              className="blue-rounded-border col-sm-12 col-md-6 offset-md-3 light-blue-bg"
              style={{ minHeight: "320px" }}
            >
              <LdsImage
                src={PetScan}
                alt="Icon of a person undergoing a scan with text: '10 minute PET scan.'"
                style={{ maxWidth: "100px" }}
                className="mx-auto d-block mt-3 mb-3 mt-5"
              />
              <p className="h5 text-center b mb-5 trade">
                <span className="fz-display d-inline-block col-sm-12">10</span>
                Minute PET Scan
              </p>
            </div>
            <div className="col-sm-12">
              <LdsImage
                src={DownArrow}
                alt="Down arrow"
                style={{ maxWidth: "60px" }}
                className="mx-auto d-block mt-4 mb-4"
              />
            </div>
            <div
              className="blue-rounded-border col-sm-12 col-md-6 offset-md-3 light-blue-bg"
              style={{ minHeight: "320px" }}
            >
              <LdsImage
                src={Clock}
                alt="Icon of a clock with text with text: 'Up to 60 minutes of stable image contrast following 30-minute uptake.' Additional text highlights flexibility for scheduling and technical delays, and the opportunity for a repeat scan if necessary."
                style={{ maxWidth: "100px" }}
                className="mx-auto d-block mt-3 mb-3 mt-5"
              />
              <p
                className="h5 text-center b mb-4 mx-auto trade"
                style={{ maxWidth: "280px" }}
              >
                Up to 60 minutes of stable image contrast following 30-minute
                uptake
              </p>
              <ul
                className="list-square mx-auto trade mb-5"
                style={{ maxWidth: "300px" }}
              >
                <li className="dark-gray b">
                  Provides flexibility for scheduling and technical delays
                </li>
                <li className="dark-gray b">
                  Offers an opportunity for a repeat scan, if necessary
                </li>
              </ul>
            </div>
            <p className="mt-4 h5 b">Total procedure time 40-60 minutes</p>
            <ul>
              <li>From tracer injection to scan completion</li>
            </ul>
            <p className="blue b">
              Minimal patient preparation required prior to scan<sup>1,2</sup>
            </p>
            <ul>
              <li className="b">No contraindications</li>
              <li className="b">No glucose monitoring or fasting required</li>
            </ul>
            <p>
              The patient should be supine with the head positioned to center
              the brain, including the cerebellum, in the PET scanner field of
              view. Reducing head movement with tape or other flexible head
              restraints may be employed. Image reconstruction should include
              attenuation correction with resulting transaxial pixel sizes
              between 2 and 3 mm.
            </p>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-2-5", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-2", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Amyvid (florbetapir F 18 injection) Prescribing Information.
                Lilly USA, LLC.
              </li>
              <li>
                Trembath L, et al. <em>J Nucl Med Technol.</em>{" "}
                2015;43(3):175-184.
              </li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_3_1;
